module.exports = __webpack_public_path__ + "img/our_logo.78fa296e.png";